import { ApolloProvider } from '@apollo/client/react'
import MuiThemeProvider from '@mui/material/styles/ThemeProvider'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { RouterContainer } from '@containers/router.container'
import { RootLayout } from '@layouts/root'
import { MuiTheme } from '@styles/theme.mui'
import { GlobalStyle, StyledTheme } from '@styles/theme.styled'

import { apolloClient } from '@libs/apollo/client'
import { useClarity } from '@libs/clarity/useClarity'
import { useCrisp } from '@libs/crisp/useCrisp'
import { AnchoredToaster, Toaster } from '@libs/toast'
import { initializeAuth } from '@libs/zustand/auth/auth.store'

import type { JSX } from 'react'

initializeAuth().catch(console.error)

export const RootContainer = (): JSX.Element => {
  useClarity()
  useCrisp()

  return (
    <RootLayout>
      <MuiThemeProvider theme={MuiTheme}>
        <StyledThemeProvider theme={StyledTheme}>
          <GlobalStyle />
          <ApolloProvider client={apolloClient}>
            <RouterContainer />
          </ApolloProvider>
          <Toaster />
          <AnchoredToaster />
        </StyledThemeProvider>
      </MuiThemeProvider>
    </RootLayout>
  )
}
